import { ShippingDocumentService } from 'src/app/core/services/shipping-document.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeaveWarehouseService {

  constructor(
    private http: HttpClient,
    private documentService: ShippingDocumentService) { }

  /**
   * Get all leaveWarehouse.
   */
  queryLeaveWarehouseHeaderPortal(param: any): Observable<any> {
    const url = `${environment.whOutboundApiUrl}/leaveWarehouse/queryLeaveWarehouseHeaderPortal`;
    return this.http.post(url, param);
  }

  /**
   * Get all leaveWarehouseDetail.
   */
  queryLeaveWarehouseDetailPortal(param: any): Observable<any> {
    const url = `${environment.whOutboundApiUrl}/leaveWarehouse/queryLeaveWarehouseDetailPortal`;
    return this.http.post(url, param);
  }

}
